var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4419 4.28287C15.6282 2.43152 19.5446 2.46388 22.7009 4.36764C25.8263 6.31016 27.7257 9.777 27.7082 13.5064C27.6353 17.2112 25.5985 20.6938 23.0525 23.386C21.583 24.9469 19.9392 26.3271 18.1545 27.4985C17.9707 27.6047 17.7694 27.6759 17.5605 27.7084C17.3594 27.6999 17.1635 27.6404 16.9906 27.5355C14.266 25.7755 11.8757 23.5289 9.93461 20.9038C8.3104 18.7125 7.38763 16.0651 7.29163 13.3211L7.2989 12.9219C7.43151 9.34019 9.36945 6.0681 12.4419 4.28287ZM18.8231 10.2591C17.5278 9.70855 16.0344 10.0077 15.0402 11.0168C14.046 12.026 13.7471 13.5461 14.2831 14.8675C14.8191 16.1888 16.0842 17.0507 17.4877 17.0507C18.4072 17.0573 19.2911 16.689 19.9424 16.0279C20.5937 15.3667 20.9584 14.4677 20.9551 13.5311C20.96 12.1014 20.1183 10.8097 18.8231 10.2591Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.4999 32.0834C21.527 32.0834 24.7916 31.4305 24.7916 30.6251C24.7916 29.8197 21.527 29.1667 17.4999 29.1667C13.4728 29.1667 10.2083 29.8197 10.2083 30.6251C10.2083 31.4305 13.4728 32.0834 17.4999 32.0834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation8);
export default __webpack_public_path__ + "static/media/Location (8).69bbb6d9e7441c82950ddf2eb780c090.svg";
export { ForwardRef as ReactComponent };